import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useId } from "react";
import { Dropdown } from "react-bootstrap";

export type CloseLoopGridActionColumnProps = {
    toggleInclude: () => void;
    isInExport: boolean;
};

const CloseLoopGridActionColumn = ({
    toggleInclude,
    isInExport
}: CloseLoopGridActionColumnProps) => {
    const menuId = useId();
    const toggleId = useId();

    return <Dropdown id={menuId} className="caret-off w-100">
        <Dropdown.Toggle id={toggleId} as={FontAwesomeIcon} className="has-pointer" icon={['fas', 'ellipsis']} />
        <Dropdown.Menu>
            <Dropdown.Item onClick={toggleInclude}>Ignore Application {!isInExport && <FontAwesomeIcon icon="check" className="text-success ms-2" />}</Dropdown.Item>
        </Dropdown.Menu>
    </Dropdown>;
};

export default CloseLoopGridActionColumn;